import { useLayoutEffect } from "react"
import type { IAccount } from "../Types/Generated/LogbookModel/Account"
import type { IAccountUserLevel } from "../Types/Generated/LogbookModel/AccountUser"
import type { ILogbookSession, ISessionResponse } from "../Types/Generated/LogbookModel/Session"
import { accountSessionResult } from "./AccountSession"
import { useDataStore } from "./Context"
import { required, useEntity, useQuery } from "./useStore"
import { useRetainedEntities } from "./useRetainedEntities"

interface AccountDataOptions {
  session?: ILogbookSession;
  response?: ISessionResponse;
}

export function useAccountData({
  session,
  response,
}: AccountDataOptions): { account?: IAccount; accountUserLevel?: IAccountUserLevel } {
  const store = useDataStore();
  const storedAccount = useEntity(store, "Account", session?.accountId ?? -1);
  const storedAccountUsers = useQuery(store, "AccountUser", {
    accountId: required(session?.accountId),
    userId: required(session?.userId),
  });

  useLayoutEffect(() => {
    if (response) {
      store.applyBundlePreservingLive(accountSessionResult(response));
    }
  }, [store, response]);

  useRetainedEntities(["Account", "AccountUser"], true);

  return {
    account: storedAccount,
    accountUserLevel: storedAccountUsers[0]?.accountLevel,
  };
}
